import styled from 'styled-components';

import { Button, Title } from '@xsolla/ui-core';
import { AlertExclamationColorful } from '@xsolla/ui-icons';

import { VerticalHorizontalCenterColumnBlock } from '../../../styled';

const calcHeight = (showTabs: boolean) => `calc(100vh - ${showTabs ? '118px' : '64px'})`;

export const Wrapper = styled(VerticalHorizontalCenterColumnBlock)`
  height: calc(100vh - 304px);
`;

export const PageWrapper = styled.div<{ showTabs: boolean }>`
  min-height: ${(p) => calcHeight(p.showTabs)};
`;

export const ModalWrapper = styled.div<{ showTabs: boolean }>`
  height: ${(p) => calcHeight(p.showTabs)};
`;

export const StyledAlert = styled(AlertExclamationColorful)`
  margin-bottom: 8px;
`;

export const Text = styled.p`
  text-align: center;
  max-height: 310px;
  overflow: hidden;
`;

export const Footer = styled.p`
  ${(p) => p.theme.typography.subHeader};
  position: absolute;
  bottom: 75px;

  span:not(:first-child) {
    margin-left: 8px;
  }

  span:not(:last-child) {
    margin-right: 8px;
  }
`;

export const StyledTitle = styled(Title)`
  color: white;
`;

export const StyledButton = styled(Button)`
  margin-top: 32px;
`;
